<template>
  <div class="box">
    <div v-if="!verified" class="QR fc" node-type="qr-btn" @click="scanCodeFn">
      <van-icon name="scan" color="#3088c5" size="0.52rem" /><span>扫码经销商所出示二维码，快速完善信息</span>
    </div>
    <!-- <van-field v-model="carNickName" required label="车辆昵称" placeholder="请输入车辆昵称" clearable /> -->
    <van-field
      v-model="plate"
      label="车牌号"
      :readonly="verified"
      placeholder="请输入车牌号"
      clearable
      @click-input="
        () => {
          if (verified) {
            clickUneditedField()
            return
          }
        }
      "
    />
    <van-field
      v-model="vin"
      required
      :readonly="verified || scanQRCode"
      label="车架号"
      placeholder="请输入车架号"
      @click-input="
        () => {
          if (verified || scanQRCode) {
            clickUneditedField()
            return
          }
        }
      "
      clearable
      @focus="fetchCarInfoWithVin = true"
    />
    <van-field
      v-model="modelInfo"
      required
      readonly
      label="车型"
      @click-right-icon="
        () => {
          if (!isCreate || verified || scanQRCode || autoFilledByVin) {
            clickUneditedField()
            return
          }
          showClass += 1
        }
      "
      right-icon="arrow"
      placeholder="请选择车型"
    />
    <!-- <van-field v-model="baumuster" :readonly="verified" label="baumuster" placeholder="请输入baumuster" clearable /> -->
    <van-field v-model="fin" label="FIN" required readonly placeholder="FIN" clearable @click-input="clickUneditedField" />
    <van-field v-model="carActiveCity" readonly label="用车地址" @click-right-icon="onClickAddress" placeholder="请选择用车地址" right-icon="arrow" />
    <van-field required readonly label-width="100px" label="三包/首登日期" @click-right-icon="clickGuaranteesDate" right-icon="" />
    <div class="timeBox">
      <div class="flexSty">
        <span>三包日期</span>
        <div class="timeSty" @click="clickGuaranteesDate(1)">
          <img src="../../../assets/images/timer.png" alt="" /> <span>{{ guaranteesDate ? guaranteesDate : '三包日期' }}</span>
        </div>
      </div>
      <div class="flexSty">
        <span>首登日期</span>
        <div class="timeSty" @click="clickGuaranteesDate(2)">
          <img src="../../../assets/images/timer.png" alt="" /> <span>{{ dateOfFirstRegistration ? dateOfFirstRegistration : '首登日期' }}</span>
        </div>
      </div>
    </div>
    <div class="fvlr setDeafault van-cell">
      <div class="fhl">
        <div>设为默认车辆</div>
        <div class="tip">购买致友计划时会默认绑定该车辆</div>
      </div>
      <van-switch v-model="isDefault" size="24px" active-color="#3088c5" />
    </div>
    <Load :isShow="loadingCarInfo" />
    <AddPhone v-if="!isCreate" :data="mobiles" @update="updatePhoneData" />
    <div class="foot">
      <div class="tip fc hasConfirm" v-if="verified"><img class="flagImg" src="../../../assets/images/flag.png" />经销商已认证过车辆信息，关键信息锁定</div>
      <div class="tip fc" v-else><van-icon name="info-o" />系统数据仅供参考，具体以经销商确认为准</div>
      <div class="terms-container">
        <van-checkbox v-model="agreeTerms">同意绑定车辆</van-checkbox> <span class="severPaction" @click="showAgreementPopUp += 1">协议条款</span>
      </div>
      <div class="btnBox fc">
        <van-button @click="del" plain type="primary" v-if="!isCreate" color="#c30000" class="del">删除车辆</van-button>
        <van-button @click="change" type="primary" :disabled="!agreeTerms" color="#3088c5">{{
          isCreate ? (scanQRCode ? '确认绑定' : '新建') : '保存'
        }}</van-button>
      </div>
    </div>
    <SelectCar :showPopUp="showClass" @selectCarResult="selectCarResult" from="plan" :initCarText="initCarTextNum" />
    <SelectCity
      :showPopUp="showCityPicker"
      :showNum="showNum"
      :fromTyre="displayCityId"
      :indexArr="cityIndexArr"
      @getCity="getCity"
      :provinceCity="carActiveProvinceId && carActiveCityId && [carActiveProvinceId, carActiveCityId]"
    />
    <van-action-sheet v-model:show="showCalendar" title="" safe-area-inset-bottom>
      <van-datetime-picker
        v-model="selectTime"
        @confirm="confirmData"
        type="date"
        @cancel="showCalendar = false"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-action-sheet>
  </div>
  <!-- 服务协议弹窗 -->
  <PopUp :showPopUp="showAgreementPopUp" :datas="contractData">
    <ServiceDeal :datas="contractData.contents" />
  </PopUp>
</template>

<script>
import { reactive, toRefs, onMounted, watch } from 'vue'
import Load from '@/components/oab/fullLoad.vue'
import SelectCar from '@/components/common/SelectCar'
import SelectCity from '@/components/common/SelectCity'
import PopUp from '@/components/common/PopUp'
import AddPhone from '@/components/directSales/AddPhone'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { Toast, Dialog } from 'vant'
import { scanCode } from '@/api/wx'
import { getParamsInUrl, getSession, setSession } from '@/util'
import { updateCarInfo, delCarInfo, addCarInfo, getCarAgeByDate, getCarInfoWithVin } from '@/api/car'
import { getAllProvinces } from '@/api/tyre'
import { addEightHour, timeAddSecond } from '@/util/index'
import { contractData } from '@/assets/js/tyreContract'
import ServiceDeal from '@/components/common/serviceDeal'
import { plateValidator } from '@/util/regEx.js'
import moment from 'moment'
import _ from 'lodash'
import { getPhoneParam } from '@/hooks/directSales/useAddPhone'

export default {
  components: {
    SelectCar,
    SelectCity,
    Load,
    PopUp,
    ServiceDeal,
    AddPhone
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    let { currentCarInfo: carInfo, myCarList: carList } = store.state
    let { isCreate, currentTime, from, carInfo: QRCarInfo, boUserId, loyaltyId, gsCode, createdBy: createdByInQuery } = route.query
    store.dispatch('setCurrentCarClassInfo', { iArr: null, baumuster: '', series: '' })
    const state = reactive({
      calendarType: 1,
      agreeTerms: true,
      minDate: new Date(1980, 0, 1),
      maxDate: new Date(),
      showCalendar: false,
      showCityPicker: false,
      showClass: 0,
      showNum: 0,
      showAgreementPopUp: 0,
      contractData,
      autoFilledByVin: false,
      initCarTextNum: 0,
      displayCityId: true,
      fetchCarInfoWithVin: false,
      scanQRCode: false,
      loadingCarInfo: false,
      statusFlag: 1,
      createdBy: '',
      // carNickName: '',
      guaranteesDate: '',
      dateOfFirstRegistration: '',
      carActiveCity: (store.state.locationInfo && store.state.locationInfo.city) || '',
      carActiveProvince: (store.state.locationInfo && store.state.locationInfo.province) || '',
      carActiveProvinceId: '',
      carActiveCityId: '',
      cityIndexArr: null,
      plate: '',
      vin: '',
      modelInfo: '',
      carAge: '',
      fin: '',
      warrantyExpirationDate:'',
      isDefault: carList?.length ? false : true,
      isCreate: isCreate === 'true',
      baumuster: '',
      selectTime: new Date(),
      boUserId,
      verified: false,
      loyaltyId,
      gsCode,
      mobiles: []
    })
    watch(
      () => state.vin,
      (curVin, preVin) => checkCurrentVin(curVin, preVin)
    )

    const checkCurrentVin = _.debounce((curVin, preVin) => {
      if (curVin && preVin !== state.fin) {
        state.autoFilledByVin = false
      }
      if (curVin === '' || state.fetchCarInfoWithVin === false) {
        return
      }
      if (curVin && !curVin.match(/^[0-9a-zA-Z]{17,18}$/)) {
        Toast('请填写17位或18位数字或字母的VIN码')
        return
      }

      if (preVin && preVin === state.fin) {
        return
      }

      updateCarInfoWithVin()
    }, 500)
    const updateCarInfoWithVin = async () => {
      state.loadingCarInfo = true
      const carInfo = await getCarInfoWithVin(state.vin)
      state.loadingCarInfo = false
      if (carInfo?.baumuster) {
        state.autoFilledByVin = true
        const initSeries = carInfo.series || 'baumusterOnly'
        store.dispatch('setCurrentCarClassInfo', { iArr: null, baumuster: carInfo.baumuster, series: initSeries })
        state.initCarTextNum++
        state.warrantyExpirationDate = carInfo.warrantyExpirationDate
        state.fin = carInfo.fin
        state.vin = carInfo.vin
        state.guaranteesDate = carInfo.threeGuaranteesDate && addEightHour(carInfo.threeGuaranteesDate, 'day')
        state.dateOfFirstRegistration = carInfo.dateOfFirstRegistration && addEightHour(carInfo.dateOfFirstRegistration, 'day')
        state.selectTime = new Date(state.guaranteesDate)
        state.isCreate ? getCarAgeByInterface() : getCarAge(new Date(state.guaranteesDate))
      } else {
        Toast('未匹配到对应Vin码信息')
        // 即使未匹配到 也不能修改
        state.autoFilledByVin = true
        store.dispatch('setCurrentCarClassInfo', { iArr: null, baumuster: '', series: '' })
        state.fin = ''
        state.guaranteesDate = ''
        state.dateOfFirstRegistration = ''
        state.selectTime = new Date()
        state.carAge = ''
        state.modelInfo = ''
      }
    }
    const clickUneditedField = () => {
      if (!state.isCreate || state.verified || state.scanQRCode || state.autoFilledByVin) {
        Toast('如车辆信息不准确，请联系经销商')
      }
    }

    const clickGuaranteesDate = type => {
      if (!state.isCreate || state.verified || state.scanQRCode || state.autoFilledByVin) {
        Toast('如车辆信息不准确，请联系经销商')
        return
      }
      // if (!state.isCreate) return
      // state.calendarType = type
      // state.showCalendar = true
    }
    const updatePhoneData = data => {
      state.mobiles = data
    }
    const getCarAge = date => {
      if (!date) return
      let start_date = moment(date)
      let end_date = moment(currentTime)
      state.carAge = end_date.diff(start_date, 'days') <= 2 ? '新车' : end_date.diff(start_date, 'years') + 1
    }
    let getCarAgeByInterface = async () => {
      let carAge
      if (state.guaranteesDate) {
        let { carAge: carAgeRes } = await getCarAgeByDate({
          threeGuaranteesDate: timeAddSecond(state.guaranteesDate)
        })
        carAge = carAgeRes
      }
      state.carAge = carAge ? carAge : '新车'
    }
    const confirmData = date => {
      state.showCalendar = false
      if (state.calendarType == 1) {
        state.guaranteesDate = addEightHour(date, 'day')
        state.isCreate ? getCarAgeByInterface() : getCarAge(date)
      } else {
        state.dateOfFirstRegistration = addEightHour(date, 'day')
      }
    }
    const selectCarResult = data => {
      state.modelInfo = data.text
      state.baumuster = data.baumuster
    }

    const getCity = data => {
      state.carActiveCity = data.name
      state.carActiveCityId = data.id
      state.carActiveProvinceId = data.provinceInfo.provinceId
      state.carActiveProvince = data.provinceInfo.text
    }

    const onClickAddress = () => {
      state.showCityPicker = !state.verified
      state.showNum += 1
    }
    const del = () => {
      Dialog.confirm({
        title: '提示',
        message: '确认删除该车辆信息'
      }).then(async () => {
        try {
          await delCarInfo({ id: carInfo.id })
          store.dispatch('setCurrentCarInfo', {})
          Toast('删除该车辆信息成功')
          store.dispatch('getMyDdefaultCar')
          setTimeout(() => {
            router.go(-1)
          }, 1500)
        } catch (error) {
          // console.log('删除该车辆----', error)
          Toast(error.message || '删除失败！')
        }
      })
    }
    const change = async () => {
      if (!state.vin) {
        Toast('车架号不能为空')
        return
      }
      if (!state.fin) {
        Toast('FIN不能为空')
        return
      }
      if (!state.modelInfo) {
        Toast('车型不能为空')
        return
      }
      if (!state.guaranteesDate && !state.dateOfFirstRegistration) {
        Toast('三包/首登日期不能为空')
        return
      }
      if (state.plate && !state.plate.match(plateValidator)) {
        Toast('车牌号格式有误')
        return
      }
      if (state.vin && !state.vin.match(/^[0-9a-zA-Z]{17,18}$/)) {
        Toast('请填写17位或18位数字或字母的VIN码')
        return
      } else {
        let hasOne = carList && carList.find(item => item.vin && item.vin === state.vin && (state.isCreate ? true : item.id !== carInfo.id))
        if (carList && hasOne) {
          Toast('您已有一台相同VIN码的车辆，请检查车辆信息')
          return
        }
      }
      if (state.fin && !state.fin.match(/^[a-zA-Z0-9]{3}[0-9]{6}[a-zA-Z0-9]{2}(?!0{6})\d{6}[a-zA-Z0-9]{0,1}$/)) {
        Toast('请填写17位或18位数字或字母的FIN码，4-9位必须为数字,12-17位必须为数字,起始范围000001~999999')
        return
      } else {
        let hasOne = carList && carList.find(item => item.fin && item.fin === state.fin && (state.isCreate ? true : item.id !== carInfo.id))
        if (carList && hasOne) {
          Toast('您已有一台相同FIN码的车辆，请检查车辆信息')
          return
        }
      }
      // if (state.fin === state.vin) {
      //   Toast('车架号和FIN码不应相同')
      //   return
      // }
      createCarInfo()
    }
    const createCarInfo = _.debounce(async () => {
      let params = {
        carAge: state.carAge === '新车' ? 0 : state.carAge,
        defaultFlag: !!state.isDefault,
        fin: state.fin ? state.fin.toUpperCase() : '',
        plate: state.plate,
        threeGuaranteesDate: timeAddSecond(state.guaranteesDate),
        warrantyExpirationDate: timeAddSecond(state.warrantyExpirationDate),
        firstRegistrationDate: state.dateOfFirstRegistration && timeAddSecond(state.dateOfFirstRegistration),
        vin: state.vin.toUpperCase(),
        baumuster: state.baumuster,
        customerId: 1,
        model: state.modelInfo,
        provinceId: state.carActiveProvinceId,
        provinceName: state.carActiveProvince,
        cityId: state.carActiveCityId,
        cityName: state.carActiveCity,
        statusFlag: state.statusFlag,
        createdBy: state.createdBy,
        mobiles: getPhoneParam(state.mobiles, state)
      }
      if (!state.isCreate) {
        let { baumuster, createTime, customerId, id, statusFlag } = carInfo
        let oldInfo = {
          createTime,
          id,
          statusFlag,
          updateTime: '',
          customerId,
          baumuster: state.baumuster || baumuster
        }
        Object.assign(params, oldInfo)
      }
      try {
        let res = params
        if (state.isCreate) {
          res = await addCarInfo(params)
        } else {
          await updateCarInfo(params)
        }
        store.dispatch('setCurrentCarInfo', res)
        if (from === 'QRcode') {
          Toast('车辆信息更新成功')
          setTimeout(() => {
            const { fromSelectCarAction } = route.query
            if (fromSelectCarAction === 'true') {
              router.go(-1)
            } else {
              router.push({ path: '/carList', event: '更新车辆信息成功' })
            }
          }, 1500)
        } else {
          Toast('新增车辆成功')
          if (getSession('urlCount') !== 1) {
            router.go(-1)
          } else {
            router.push({ path: '/carList', event: '更新车辆信息成功' })
          }
        }
      } catch (e) {
        Toast(e.message || '操作失败')
      }
    }, 500)
    function init(carInfo) {
      // state.carNickName = carInfo.nickName
      state.plate = carInfo.plate
      state.vin = carInfo.vin
      state.modelInfo = carInfo.model
      state.baumuster = carInfo.baumuster
      state.guaranteesDate = carInfo.threeGuaranteesDate && addEightHour(carInfo.threeGuaranteesDate, 'day')
      state.dateOfFirstRegistration =
        (carInfo.firstRegistrationDate && addEightHour(carInfo.firstRegistrationDate, 'day')) ||
        (carInfo.evaFirstRegistrationDate && addEightHour(carInfo.evaFirstRegistrationDate, 'day'))
      state.selectTime = new Date(state.guaranteesDate)
      state.fin = carInfo.fin
      state.mobiles = carInfo.mobiles || []
      getCarAge(state.guaranteesDate)
      state.verified = carInfo.statusFlag === 2
      state.isDefault = !!carInfo.isDefault || !!carInfo.defaultFlag //carInfo.isDefault二维码扫描都设置为默认车辆
      state.carActiveCity = carInfo.cityName
      state.carActiveProvince = carInfo.provinceName

      state.warrantyExpirationDate = carInfo?.warrantyExpirationDate
      state.carActiveProvinceId = carInfo.provinceId
      state.carActiveCityId = carInfo.cityId
      store.commit('SETBOUSERINFO', {
        id: state.boUserId
      })
      if (carInfo.baumuster) {
        const initSeries = carInfo.series || 'baumusterOnly'
        store.dispatch('setCurrentCarClassInfo', { iArr: null, baumuster: carInfo.baumuster, series: initSeries })
      }
    }
    const extractCityNameAndId = carInfo => {
      if (!Array.isArray(carInfo?.carCity) || carInfo?.carCity?.length < 1) {
        return {
          provinceId: null,
          cityId: null,
          provinceText: null,
          cityText: null
        }
      }
      const provinceId = Number(carInfo.carCity[0].split('-')[0])
      const cityId = Number(carInfo.carCity[1].split('-')[0])
      const provinceText = carInfo.carCity[0].split('-')[1]
      const cityText = carInfo.carCity[1].split('-')[1]

      return {
        provinceId,
        cityId,
        provinceText,
        cityText
      }
    }
    const scanCodeFn = async () => {
      state.fetchCarInfoWithVin = false
      let url = await scanCode()
      const carInfoJSON = getParamsInUrl(decodeURI(url)).carInfo || '{}'
      const carInfo = JSON.parse(carInfoJSON)
      state.scanQRCode = true
      state.statusFlag = 1 //七哥指示--认证车辆只有一个只有计划接单途径，扫码添加的都是未认证{1-未认证，2-已认证，3-删除}
      state.cityIndexArr = null
      let { plate, vin, fin, threeGuaranteesDate, baumuster, model } = carInfo
      const { provinceId, cityId, provinceText, cityText } = extractCityNameAndId(carInfo)
      // handle no id case: id is 0
      carInfo.provinceId = provinceId === 0 ? provinceText : provinceId
      carInfo.cityId = cityId === 0 ? cityText : cityId
      carInfo.provinceName = provinceText
      carInfo.cityName = cityText
      let boUserId = carInfo.boUserId
      let loyaltyId = carInfo.loyaltyId
      let gsCode = carInfo.gsCode
      const createdBy = carInfo.createdBy
      if (loyaltyId) {
        store.commit('SETSHOWDIFFCARTIP', true)
        sessionStorage.removeItem('showType')
        toPlanDetail(carInfo, loyaltyId, gsCode)
        return
      }

      state.createdBy = createdBy
      state.plate = plate
      state.vin = vin
      state.fin = fin
      state.modelInfo = model
      state.baumuster = baumuster
      state.guaranteesDate = threeGuaranteesDate && addEightHour(threeGuaranteesDate, 'day')
      state.dateOfFirstRegistration =
        (carInfo.firstRegistrationDate && addEightHour(carInfo.firstRegistrationDate, 'day')) ||
        (carInfo.evaFirstRegistrationDate && addEightHour(carInfo.evaFirstRegistrationDate, 'day'))
      state.selectTime = new Date(state.guaranteesDate)
      state.carActiveCity = carInfo.cityName
      state.carActiveProvince = carInfo.provinceName
      state.carActiveProvinceId = carInfo.provinceId
      state.carActiveCityId = carInfo.cityId
      getCarAge(state.guaranteesDate)
      state.isDefault = true
      state.boUserId = boUserId
      store.commit('SETBOUSERINFO', { id: boUserId })
      if (carInfo.baumuster) {
        const initSeries = carInfo.series || 'baumusterOnly'
        store.dispatch('setCurrentCarClassInfo', { iArr: null, baumuster: carInfo.baumuster, series: initSeries })
      }
    }
    const toPlanDetail = (carInfo, Id, gscode) => {
      let loyaltyId = Id || loyaltyId
      let gsCode = gscode || gsCode
      carInfo = JSON.stringify(carInfo)
      router.push({
        path: '/planDetail',
        query: {
          carInfo,
          loyaltyId,
          gsCode,
          from: 'scan',
          event: '扫描车辆信息自动跳转计划详情'
        }
      })
    }

    onMounted(async () => {
      let list = getSession('getAllProvinces')
      if (!list) {
        const { provinces } = await getAllProvinces()
        setSession('getAllProvinces', provinces)
        list = provinces
      }
      if (state.carActiveProvince && state.carActiveCity) {
        const province = list.find(v => v.name === state.carActiveProvince)
        if (province) {
          state.carActiveProvinceId = province.id
          state.carActiveCityId = province.cities.find(v => v.name === state.carActiveCity).id
        }
      }

      // scan QRCode to page directly
      if (state.isCreate) {
        if (from === 'QRcode') {
          QRCarInfo = QRCarInfo.replace(/\\"/g, '"')
          eval('(' + QRCarInfo + ')')
          let carInfo = JSON.parse(QRCarInfo)
          const { provinceId, cityId, provinceText, cityText } = extractCityNameAndId(carInfo)
          carInfo.provinceId = provinceId === 0 ? provinceText : provinceId
          carInfo.cityId = cityId === 0 ? cityText : cityId
          carInfo.provinceName = provinceText
          carInfo.cityName = cityText
          state.scanQRCode = true
          state.statusFlag = 2
          state.createdBy = createdByInQuery
          if (loyaltyId) {
            toPlanDetail(carInfo)
          } else {
            init(carInfo)
          }
        }
      } else {
        init(carInfo)
      }
    })
    return {
      ...toRefs(state),
      confirmData,
      selectCarResult,
      updateCarInfoWithVin,
      getCity,
      onClickAddress,
      del,
      change,
      scanCodeFn,
      clickUneditedField,
      clickGuaranteesDate,
      updatePhoneData
    }
  }
}
</script>

<style lang="scss" scoped>
.flexSty {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 50px;
  margin-bottom: 5px;
}
.timeBox {
  background: white;
  .timeSty {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // margin: 0 auto;
    margin-left: 25px;
    width: 150px;
    height: 30px;
    border: 1px solid rgb(155, 155, 157);
    border-radius: 3px;
  }
}
.terms-container {
  display: flex;
  align-items: center;
  line-height: 20px;
  margin: 20px 0 0;
}
.box {
  padding: 0 0 40px;
  width: 100vw;
  box-sizing: border-box;
}
.QR {
  color: #3088c5;
  font-size: 14px;
  padding: 10px 0;
  border: 1px solid #3088c5;
  margin: 16px 20px;
  box-sizing: border-box;
  i {
    margin-right: 10px;
  }
}
.van-cell {
  padding-left: 25px;
  padding-right: 20px;
}
.van-cell--required::before {
  left: 18px;
}
.van-cell::after {
  padding-left: 25px;
  padding-right: 25px;
}
.van-field__right-icon {
  margin-right: 0;
}
.setDeafault {
  font-size: 14px;
  color: #333333;
  .tip {
    font-size: 12px;
    color: #999999;
  }
}
.foot {
  padding: 42px 20px;
  color: #999999;
  background: #ffffff;
  i {
    margin-right: 4px;
  }
  img {
    width: 16px;
    height: 11px;
    margin-right: 4px;
  }
  .hasConfirm {
    color: #f49b55;
  }
}
.btnBox {
  padding-top: 16px;
  .del {
    margin-right: 15px;
  }
  button {
    width: 100%;
  }
}
.iconImg {
  width: 18px;
  height: 16px;
  margin-right: 8px;
  vertical-align: middle;
}

.severPaction {
  color: #3088c5;
  text-decoration: underline;
  text-decoration-color: #3088c5;
}
</style>
